import React, { useEffect, useState } from "react";
import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import toast from "react-hot-toast";
import { api } from "../../../../../../api/report";
import { useLocation, useNavigate } from "react-router";
import pptxgen from "pptxgenjs";
import Pptx from "pptxgenjs";

import { dataToPptx as pptxData } from "./dataToPppttest";
import { downloadpptx } from "../utils/dowloadpptx.utils";
import useDownloadReport from "../utils/useDownloadReport";

type ReportPayload = {
  name: string;
  description: string;
  type: string;
  size: string;
  orientation: string;
  width: number | null;
  height: number | null;
  pixels: number | null;
  status: string;
  pages: { sort: number; page: string }[];
};

export type ReportData = {
  name: string;
  description: string;
  type: string;
  size: string;
  orientation: string;
  width: number;
  height: number;
  pixels: number;
  status: string;
  orgId: string;
  id: string;
};

type HeaderType = {
  setTitle: React.Dispatch<React.SetStateAction<string>>;
  title: string;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setOpenPreviewReportModal: React.Dispatch<React.SetStateAction<boolean>>;
  pages: any[];
  setIsPreview: React.Dispatch<React.SetStateAction<boolean>>;
  pageStructure: any[];
  data: ReportData;
  reportId: string | null;
  action: string | null;
};

const Header: React.FC<HeaderType> = ({
  title,
  setIsPreview,
  setTitle,
  action,
  setOpen,
  setOpenPreviewReportModal,
  pages,
  pageStructure,
  data,
  reportId,
}): JSX.Element => {
  const changeTitle = (event: React.ChangeEvent<HTMLHeadingElement>): void => {
    setTitle(event.target.innerText);
  };
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const source = searchParams.get("source");
  const reportTitle = searchParams.get("title");
  const navigate = useNavigate();
  const user = sessionStorage.getItem("user")?.trim() === ""
      ? null
      : JSON.parse(sessionStorage.getItem("user") ?? "{}");
  const [elements, setElements] = useState<any[]>([]);

  useEffect(() => {
    const savedData = sessionStorage.getItem("reportData");
    const elementsData = sessionStorage.getItem("elements");
    if (savedData) {
      const payload: ReportData = JSON.parse(savedData);
      // setData(payload);
      if (elementsData !== null) {
        setElements(JSON.parse(elementsData));
      } else {
        setElements([]);
      }
    }
  }, []);
 
  const {handleSubmit} : any = useDownloadReport({data, pages, pageStructure, reportTitle});

  const pres = new Pptx();
  type ShapeTypeNames = keyof typeof pres.ShapeType;

  interface Shape {
    type: ShapeTypeNames;
    // other properties...
  }
  interface Element {
    shape: Shape;
    // other properties...
  }

  

  return (
    <div className="bg-primary-blue text-white mt-4 py-2 flex justify-between items-center px-3">
      <div className="flex items-center">
        <button className="bg-transparent text-sm text-white">
          Menu <i className="bi bi-chevron-down ml-2 text-white"></i>
        </button>
        <div className="w-[1px] h-[40px] bg-white ml-5"></div>
        <h3
          //contentEditable
          //onInput={changeTitle}
          className="text-white textsm font-semibold ml-5"
        >
          {data?.name || reportTitle}
        </h3>
      </div>
      <div>
        <button
          className="text-white border text-xs mr-3 rounded-lg py-2 bi bi-cursor px-5 border-white"
          onClick={ () => handleSubmit(true)}
        >
          &nbsp; Generate Report
        </button>
        {/* <button
          className="text-white border text-xs rounded-lg py-2 bi bi-cursor px-5 border-white"
          onClick={() => {
            setIsPreview(false);
          }}
        >
          &nbsp;Share Report
        </button> */}
        <button
          className="btn-light pt-2 pb-2 pl-8 pr-8 ml-3 bg-[#E8EDF4]"
          onClick={() => {
            setIsPreview(true);
            //setOpenPreviewReportModal(true);
          }}
        >
          Preview
        </button>
      { source !== 'filter' &&         
         <button
          onClick={() => handleSubmit(false)}
          className="btn pt-2 pb-2 pl-8 pr-8 ml-3 bg-[#CC7300]"
        >
          {reportId && action === "edit" ? "Edit Report" : "Create Report"}
        </button> 
        }
      </div>
    </div>
  );
};

export default Header;
